import React from "react";
import { Link } from "react-router-dom";
import { Star, Heart } from "lucide-react";
import { useCart } from "../context/CartContext";
import { resolveImg } from "../api";

const ProductCard = ({ product }) => {
  const { addToCart, toggleWishlist, wishlist } = useCart();
  const wished = wishlist.includes(product.id);

  return (
    <div className="group relative flex flex-col bg-white border border-neutral-200 rounded-sm overflow-hidden transition-shadow duration-300 hover:shadow-xl">
      {/* Image */}
      <Link to={`/products/${product.slug}`} className="relative block overflow-hidden bg-[#f6f3ee]">
        <div className="aspect-[3/4] w-full">
          <img
            src={resolveImg(product.image)}
            alt={product.name}
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
          />
        </div>
        {product.badges?.length > 0 && (
          <div className="absolute left-3 top-3 flex flex-col gap-1.5">
            {product.badges.map((b) => (
              <span
                key={b}
                className="bg-gradient-to-br from-[#FF8FA3] to-[#D6425F] text-white text-[10px] font-semibold tracking-wider uppercase px-2 py-1 rounded-sm"
              >
                {b}
              </span>
            ))}
          </div>
        )}
        <button
          onClick={(e) => {
            e.preventDefault();
            toggleWishlist(product.id);
          }}
          aria-label="Add to wishlist"
          className="absolute right-3 top-3 h-8 w-8 rounded-full bg-white/90 backdrop-blur flex items-center justify-center shadow-sm transition-colors hover:bg-white"
        >
          <Heart
            className={`h-4 w-4 ${wished ? "fill-[#D6425F] text-[#D6425F]" : "text-neutral-600"}`}
          />
        </button>
      </Link>

      {/* Body */}
      <div className="flex flex-1 flex-col p-4">
        <p className="text-[11px] uppercase tracking-widest text-[#C8932F] font-medium">
          {product.scent}
        </p>
        <Link
          to={`/products/${product.slug}`}
          className="mt-1 text-sm font-semibold text-neutral-900 leading-snug line-clamp-2 hover:text-[#C8932F] transition-colors"
        >
          {product.name}
        </Link>

        <div className="mt-2 flex items-center gap-1.5">
          <span className="flex items-center gap-1 bg-[#f3ede2] px-1.5 py-0.5 rounded-sm">
            <Star className="h-3 w-3 fill-[#C8932F] text-[#C8932F]" />
            <span className="text-xs font-semibold text-neutral-800">{product.rating}</span>
          </span>
          <span className="text-xs text-neutral-500">({product.reviews})</span>
        </div>

        <div className="mt-3 flex items-baseline gap-2">
          <span className="text-base font-bold text-neutral-900">
            ₹{product.price.toLocaleString("en-IN")}
          </span>
          {product.mrp > product.price && (
            <>
              <span className="text-xs text-neutral-400 line-through">
                ₹{product.mrp.toLocaleString("en-IN")}
              </span>
              <span className="text-xs font-semibold text-[#D6425F]">{product.discount}% Off</span>
            </>
          )}
        </div>
        <p className="text-[10px] text-neutral-400">Inclusive of all taxes</p>

        <button
          onClick={() => addToCart(product)}
          className="mt-4 w-full border border-[#C8932F] text-[#C8932F] text-xs font-semibold uppercase tracking-widest py-2.5 rounded-sm transition-all duration-300 hover:bg-gradient-to-br hover:from-[#FFE29A] hover:to-[#C8932F] hover:text-[#050304] hover:border-transparent"
        >
          Add To Cart
        </button>
      </div>
    </div>
  );
};

export default ProductCard;
